angular.module('account').controller('AprimaConditionsCtrl',
    ['$scope', '$stateParams', 'toaster', 'aprgettext', 'TransitionManager', 'ConsentService',
        function ($scope, $stateParams, toaster, gettext, TransitionManager, ConsentService) {
            'use strict';

            $scope.loading = true;

            ConsentService
                .getPrivacyPolicyUrl()
                .then(function (privacyPolicyUrl) {
                    $scope.removeHttpError();
                    $scope.PDFPath = privacyPolicyUrl;
                })
                .catch(function (response) {
                    $scope.addHttpError(response);
                })
                .finally(function () {
                    $scope.loading = false;
                });

            $scope.finish = function finish() {
                TransitionManager.transition({appRoute: 'dashboard'});
            };

            $scope.back = function back() {
                TransitionManager.transition({appRoute: 'accountsetup'});
            };

            $scope.finish = function finish() {
                TransitionManager.transition({appRoute: 'login'});
            };
        }]);
